"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERR_MESSAGES = {
    EMAIL_NOT_LONG_ENOUGH: "email must be at least 3 characters",
    INVALID_EMAIL: "email must be a valid email",
    DUPLICATE_EMAIL: "email taken",
    CONFIRM_EMAIL: "please confirm your email",
    USERNAME_LIMIT: "User Name must be between 5 and 15 characters",
    PASSWORD_NOT_LONG: "password must be at least 3 characters",
    PASSWORD_TOO_LONG: "password must be less than 255 characters",
    FORGOT_PASSWORD_ACCOUNT_LOCKED: "account is locked",
    FORGOT_PASSWORD_EXPIRED_KEY: "Forgot link has expired",
    INVALID_CREDENTIALS: "invalid credentials",
    USER_NOT_FOUND: "could not find user with that email",
    LOGIN_OR_REGISTER: "please login or register",
    POST_NOT_FOUND: "post not found",
    NOTING_TO_UPDATE: "nothing to update",
    USER_NOT_AUTHORISED: "user not authorised to make specified changes",
    COMMENT_EMPTY: "comment can not be empty",
    COMMENT_NOT_FOUND: "comment not found",
    DO_NOT_EXIST: " does not exist anymore",
    REPLY_EMPTY: "reply can not be empty"
};
exports.ROUTE_NAMES = {
    SPLASH: "SPLASH",
    WELCOME: "WELCOME",
    AUTH: "/auth",
    APP: "/app",
    AUTH_LOADING: "/auth-loading",
    REGISTER: "/register",
    LOGIN: "/login",
    LOGOUT: "/logout",
    HOME: "/",
    FORGOT_PASSWORD: "/forgot-password",
    CHANGE_PASSWORD: "/change-password",
    RESET_PASSWORD: "/reset-password",
    CONFIRM_EMAIL: "/confirm-email",
    MESSAGE: "/m",
    CREATE_POST: "/create-post",
    CATEGORY_LIST: "/category-list",
    POST_DETAILS: "/post-details",
    PROFILE_ROUTE: "/profile_route",
    MY_PROFILE: "/my-profile",
    EDIT_PROFILE: "/edit-profile",
    PROFILE_POST_DETAILS: "/profile-post-details",
    FILTER_AND_SORT: "/filter-and-sort",
    NOTIFICATION: "/notification",
    IS_USER_LOGGED_IN: "IS_USER_LOGGED_IN",
    USER_DETAILS: "USER_DETAILS",
    MAIN: "MAIN",
    SETTINGS: "SETTINGS",
    COMMENT_DETAILS: "COMMENT_DETAILS"
};
exports.COOKIE_ID = "qid";
exports.DATE_FORMAT = "YYYY-MM-DD HH:mm:ss.SSSZ";
exports.CategoryTypes = [
    "Politics",
    "Business",
    "Sport",
    "Technology",
    "Entertainment"
];
exports.SUBSCRIPTION = {
    NEW_COMMENT: "NEW_COMMENT",
    NEW_REPLY: "NEW_REPLY"
};
exports.FILTERS_TYPE = {
    DATES: "Dates"
};
exports.SORT_TYPE = [
    { name: "Top", key: "Score", value: "Top" },
    { name: "Latest", key: "Date", value: "Latest" }
];
exports.CATEGORY_FILTER = [
    { name: "All", value: "All" },
    { name: "Politics", value: "Politics" },
    { name: "Business", value: "Business" },
    { name: "Sport", value: "Sport" },
    { name: "Technology", value: "Technology" },
    { name: "Entertainment", value: "Entertainment" }
];
exports.DATE_FILTER = [
    { name: "Today", value: "1" },
    { name: "This Week", value: "7" },
    { name: "This Month", value: "30" },
    { name: "This Year", value: "365" },
    { name: "Eternity", value: "10000" }
];
exports.DATE_SORT = [
    { name: "Latest first", value: "DESC" },
    { name: "Oldest first", value: "ASC" }
];
exports.SCORE_SORT = [
    { name: "High to low", value: "DESC" },
    { name: "Low to high", value: "ASC" }
];
exports.COMMENT_SORT = [
    { key: "Score", value: "Top Comments" },
    { key: "Date", value: "Newest first" }
];
exports.POST_LIST_LIMIT = 10;
exports.COMMENT_LIMIT = 20;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ../common/dist/constants.js
// module id = 318
// module chunks = 0